/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { createTheme, ThemeProvider, useTheme } from '@mui/material';
import { ptBR } from '@mui/material/locale';

function DataTable({ columns, data }) {
  const [table, setTable] = useState([]);
  const theme = useTheme(); // replace with your theme/createTheme

  useEffect(() => {
    setTable(data);
  }, [data]);

  return (
    <ThemeProvider theme={createTheme(theme, ptBR)}>
      <MaterialReactTable
        columns={columns}
        data={table}
        enableRowActions={false}
        enableColumnActions={false}
        enableColumnFilters={false}
        // enablePagination={false}
        enableSorting={false}
        // enableBottomToolbar={false}
        enableTopToolbar={false}
        muiTableBodyRowProps={{ hover: true }}
        localization={MRT_Localization_PT_BR}
        initialState={{
          density: 'compact',
          showColumnFilters: false,
          showGlobalFilter: false,
          columnVisibility: { id: false },
        }}
        // Custom styling for the table body cells
      />
    </ThemeProvider>
  );
}

export default DataTable;
